export const LOCAL_LANGUAGE_KEY = 'language'; // 历史的 key 先不动

// 新的 key 以 PTI_XXX 为规范

/**
 * 本地存储的问卷 ID
 */

export const LOCAL_PTI_QUESTIONNAIRE_ID_KEY = 'PTI_QUESTIONNAIRE_ID';

/**
 * 本地存储问卷草稿 key 的前缀
 */
export const LOCAL_PTI_PROJECT_PROFILE_STEP_KEY_PREFIX = 'PTI_PROJECT_PROFILE_STEP_';

/**
 * 本地步骤的最大步骤
 */
export const LOCAL_MAX_STEP_KEY = 'PTI_MAX_STEP';
